import React, { useState, useEffect } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/MainWebsiteComponent/Footer/Footer";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import HomeIcon from "@material-ui/icons/Home";
import styles from "./Tos.module.css";
import Head from "next/head";

function InstructorTerms(props) {
  const breadcrumbsData = [
    {
      label: "Home",
      link: "/",
      icon: <HomeIcon fontSize="small" />,
    },

    {
      label: "Terms of Use",
      link: "",
    },
  ];

  return (
    <div>
      <Head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="theme-color" content="#000000" />
        <meta
          name="robots"
          content={
            process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
              ? "index, follow"
              : "noindex, nofollow"
          }
        />
        <meta
          name="googlebot"
          content={
            process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
              ? "index, follow"
              : "noindex, nofollow"
          }
        />
        <meta name="referrer" content="no-referrer-when-downgrade" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />

        <title>Takbir - Best online Islamic learning and teaching site</title>
        <meta
          name="description"
          content="Takbir is a secured, simple and easy-to-use online learning platform for learners and teachers of Islam. Learn Islam, Iman, Ihsan, Tazkiya, Akhlaq, Quran, Hadith, Fiqh, Arabic and much more in one place."
        />
        <meta
          property="og:site_name"
          content="Takbir - Best online Islamic learning and teaching site "
        />
        <meta
          property="og:description"
          content="Takbir is a secured, simple and easy-to-use online learning platform for learners and teachers of Islam. Learn Islam, Iman, Ihsan, Tazkiya, Akhlaq, Quran, Hadith, Fiqh, Arabic and much more in one place."
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:url" content="https://mytakbir.com/" />
        <meta
          property="og:title"
          content="Takbir - Best online Islamic learning and teaching site"
        />
        <meta
          property="og:image"
          content="https://cdn.mytakbir.com/static-assets/meta/web-takbir-img.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://cdn.mytakbir.com/static-assets/meta/web-takbir-img.png"
        />

        <link
          rel="icon"
          href="https://cdn.mytakbir.com/static-assets/meta/takbir-lms-learning-management-system-muslim-favicon.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon.ico" />
        {/* <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" /> */}

        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-7XY3WGDSHE"
        ></script>

        <script id="google-analytics" strategy="afterInteractive">
          {`
                            window.dataLayer = window.dataLayer || [];
                               function gtag(){window.dataLayer.push(arguments);}
                                gtag('js', new Date());
                                   gtag('config', 'G-7XY3WGDSHE');
                                  `}
        </script>

        <script id="mixpanel" strategy="afterInteractive">
          {`
                (function(e,c){if(!c.__SV){var l,h;window.mixpanel=c;c._i=[];c.init=function(q,r,f){function t(d,a){var g=a.split(".");2==g.length&&(d=d[g[0]],a=g[1]);d[a]=function(){d.push([a].concat(Array.prototype.slice.call(arguments,0)))}}var b=c;"undefined"!==typeof f?b=c[f]=[]:f="mixpanel";b.people=b.people||[];b.toString=function(d){var a="mixpanel";"mixpanel"!==f&&(a+="."+f);d||(a+=" (stub)");return a};b.people.toString=function(){return b.toString(1)+".people (stub)"};l="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders start_session_recording stop_session_recording people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
                for(h=0;h<l.length;h++)t(b,l[h]);var n="set set_once union unset remove delete".split(" ");b.get_group=function(){function d(p){a[p]=function(){b.push([g,[p].concat(Array.prototype.slice.call(arguments,0))])}}for(var a={},g=["get_group"].concat(Array.prototype.slice.call(arguments,0)),m=0;m<n.length;m++)d(n[m]);return a};c._i.push([q,r,f])};c.__SV=1.2;var k=e.createElement("script");k.type="text/javascript";k.async=!0;k.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"file:"===
                e.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";e=e.getElementsByTagName("script")[0];e.parentNode.insertBefore(k,e)}})(document,window.mixpanel||[])

                mixpanel.init('60e7a8f3c95c4e2b186ace1f2dc5aa09', {
                  autocapture: true,
                  record_sessions_percent: 100,
                })
                `}
        </script>
      </Head>
      <Header />
      <div
        style={{
          borderBottom: "1px solid rgb(235 235 235)",
          paddingTop: "22px",
        }}
      >
        <Container maxWidth="lg">
          <Breadcrumbs breadcrumbsData={breadcrumbsData} />
        </Container>
      </div>

      <div className="Section">
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <div className={styles.TosContainer}>
                <h1 className={styles.PageTitle}>Instructor Terms</h1>

                <p>
                  By registering as an instructor on the Takbir platform, you
                  are acknowledging and accepting the Instructor Terms, which
                  outline the specific features of the platform that pertain to
                  instructors. These Terms are referenced in our general Terms
                  of Services, which govern your overall use of our Services.
                </p>
                <p>
                  If any capitalized terms are left undefined in the Instructor
                  Terms, they will be defined in the Terms of Services. As an
                  instructor, you are entering into a contract directly with
                  Takbir, regardless of whether any other Takbir subsidiary is
                  responsible for processing your payments.
                </p>
                <h2>Instructor Obligations</h2>
                <p>
                  It is the duty of an instructor to take full responsibility
                  for all the content they upload, which encompasses lectures,
                  quizzes, coding exercises, practice tests, assignments,
                  resources, answers, course landing page content, labs,
                  assessments, and announcements ("Submitted Content").
                </p>
                <p>
                  By agreeing to these Terms and the Terms of Use, you are
                  confirming and promising the following:
                </p>
                <ol>
                  <li>
                    You will provide and update accurate account information.
                  </li>
                  <li>
                    You have the necessary licenses, rights, consents,
                    permissions, and authority to allow Takbir to use your
                    Submitted Content as outlined in these Terms and the Terms
                    of Use.
                  </li>
                  <li>
                    Your Submitted Content will not violate any third party's
                    intellectual property rights.
                  </li>
                  <li>
                    You possess the necessary qualifications, credentials, and
                    expertise (including education, training, knowledge, and
                    skill sets) to teach and provide the services that you offer
                    through your Submitted Content and use of the Services.
                  </li>
                  <li>
                    You will deliver a level of service that aligns with the
                    standards of your industry and instructional services in
                    general.
                  </li>
                </ol>
                <p>
                  By agreeing to use the Services, you are responsible for
                  ensuring that you do not engage in the following activities:
                </p>
                <ul>
                  <li>
                    Posting or providing any content or information that is
                    inappropriate, offensive, racist, hateful, sexist,
                    pornographic, false, misleading, incorrect, infringing,
                    defamatory, or libellous.
                  </li>
                  <li>
                    Posting or transmitting any form of unsolicited or
                    unauthorized advertising, promotional materials, junk mail,
                    spam, or any other solicitation (commercial or otherwise) to
                    users through the Services.
                  </li>
                  <li>
                    Using the Services for any purpose other than providing
                    tutoring, teaching, and instructional services to learners.
                  </li>
                  <li>
                    Engaging in any activity that would require the company to
                    obtain licenses or pay royalties to a third party, such as
                    the need to pay royalties for the public performance of a
                    musical work or sound recording.
                  </li>
                  <li>
                    Attempting to circumvent the Services, including by framing
                    or embedding the Services or impersonating another person or
                    gaining unauthorized access to another person's account.
                  </li>
                  <li>
                    Interfering with or preventing other instructors from
                    providing their services or content through the Services.
                  </li>
                  <li>Abusing Takbir resources, including support services.</li>
                </ul>
                <h2>Licence to Takbir</h2>
                <p>
                  Takbir is authorized, under the Terms of Use, to utilize,
                  promote, and profit from your Submitted Content, which may
                  involve modifying the content for accessibility purposes, and
                  sublicensing these rights to third parties, including learners
                  and various resellers, distributors, affiliate sites, deal
                  sites, and paid advertising platforms.
                </p>
                <p>
                  You are entitled to remove all or part of your Submitted
                  Content from the Services at any time, unless otherwise
                  specified in an agreement. In the absence of an agreement,
                  Takbir’s right to grant sublicenses as described in this
                  section will cease for new users for a specific amount of time
                  after your Submitted Content is removed. However, the rights
                  granted to learners prior to the removal of your Submitted
                  Content will continue in accordance with the terms of their
                  licenses (including any lifetime access grants). Additionally,
                  Takbir's right to use your Submitted Content for marketing
                  purposes will remain in effect even after termination.
                </p>
                <p>
                  We reserve the right to capture and utilize any or all of the
                  content you submit for purposes of quality assurance and to
                  facilitate the delivery, advertising, promotion,
                  demonstration, or operation of our Services. By agreeing to
                  these terms, you authorize Takbir to use your name, image,
                  voice, and likeness in association with offering, delivering,
                  advertising, promoting, demonstrating, and selling our
                  Services, your submitted content, or Takbir’s content. You
                  also relinquish any claims to privacy, publicity, or similar
                  rights to the extent allowed by applicable law.
                </p>
                <h2>Trust & Safety Policy:</h2>
                <ul>
                  <li>
                    By using Takbir’s Services, you acknowledge that you must
                    comply with Takbbir’s Trust & Safety policies and any other
                    content quality standards or policies set by Takbir from
                    time to time.{" "}
                  </li>
                  <li>
                    It is your responsibility to periodically review these
                    policies to ensure you are up to date with any changes.{" "}
                  </li>
                  <li>
                    You also understand that Takbir has the right to approve or
                    deny your use of the Services at its discretion, and
                    reserves the right to remove content, suspend payouts, or
                    ban instructors without prior notice for any reason,
                    including but not limited to cases where an instructor or
                    their content does not comply with Takbir’s policies or
                    legal terms,{" "}
                  </li>
                  <li>Falls below quality standards, </li>
                  <li>
                    Engages in behaviour that reflects unfavourably on Takbir,{" "}
                  </li>
                  <li>
                    Employs a marketer or business partner who violates Takbir’s
                    policies,{" "}
                  </li>
                  <li>
                    Uses the Services in a way that constitutes unfair
                    competition,{" "}
                  </li>
                  <li>or as determined by Takbir at its sole discretion.</li>
                </ul>
                <h2>Co-Instructors and Teaching Assistants</h2>
                <p>
                  On the Takbir platform, you have the ability to designate
                  other users as co-instructors or teaching assistants for the
                  content that you manage. However, it is imperative that you
                  adhere to our policies.
                </p>
                <p>
                  By appointing a co-instructor or teaching assistant, you are
                  granting them permission to carry out certain actions that can
                  impact your Takbir account and submitted content. If your
                  co-instructor or teaching assistant violates any of Takbir’s
                  terms and policies, it could negatively affect your Takbir
                  account and submitted content. Please note that Takbir cannot
                  provide guidance or assist in resolving disputes between you
                  and other users. Additionally, if you have designated a
                  revenue share for your co-instructors, their portion will be
                  paid from your earned revenue share.
                </p>
                <h2>Relationship to Other Users</h2>
                <p>
                  As an instructor, you do not have a direct contractual
                  relationship with learners. Therefore, the only information
                  you can access about learners is through the Services provided
                  to you. By using the data provided to you, you agree to only
                  use it for the purpose of providing your services to learners
                  on the Takbir platform.{" "}
                </p>
                <p>
                  You also agree not to request additional personal data or
                  store learners' personal data outside the Takbir platform.
                  Furthermore, you agree to indemnify Takbir against any claims
                  that may arise from your use of learners' personal data.
                </p>
                <h2>Pricing</h2>
                <p>
                  When you create Submitted Content to sell on Takbir, you will
                  be asked to choose a base price from a range of available
                  price levels. Alternatively, you can decide to provide your
                  Submitted Content for free. As a distinguished instructor, you
                  will have the chance to take part in select promotional
                  initiatives.
                </p>
                <p>
                  If you choose not to engage in any Promotional Programs, your
                  Submitted Content will be listed for the Base Price. However,
                  if you decide to participate in a Promotional Program, we
                  might establish a discounted or listed price for your
                  Submitted Content that differs from the base price, in
                  accordance with the Promotions Policy.
                </p>
                <p>
                  By submitting your content, you authorize us to freely share
                  it with our employees, selected partners, and in situations
                  where we need to restore access to accounts that have
                  previously purchased your content. It is important to note
                  that you acknowledge and agree that you will not receive any
                  compensation in these circumstances.
                </p>
                <h2>Payments</h2>
                <p>
                  Once a learner purchases your Submitted Content, we calculate
                  the total sale value by taking into account the payment
                  received by Takbir from the learner. A specific deduction is
                  applied for the platform dependent on the subscription plan
                  that you have chosen. To securely process the payment we use
                  Stripe, which deducts a percent of your sale - this is not
                  Takbir’s fee. as well as Stripe's fee, are dependent on the
                  subscription plan that you have chosen on our platform.{" "}
                </p>
                <h2>Receiving Payments</h2>
                <p>
                  Upon setting up your instructor's account, you will be asked
                  to establish a Stripe bank account so that we can make prompt
                  payments to you. Payouts will be directly from Stripe to their
                  Bank Account. We don’t save any teaching accounts, banking or
                  credit card details on our end.
                </p>
                <h2>Refunds</h2>
                <p>
                  You accept and acknowledge that learners possess the
                  entitlement to receive a refund as described in the Terms of
                  Use. Instructors will not receive any proceeds from
                  transactions where a refund has been authorized.{" "}
                </p>
                <p>
                  If a learner requests a refund subsequent to the payment being
                  made to the relevant instructor, we maintain the right to
                  either: <br /> 1. Deduct the refund amount from the
                  instructor's next payment or <br /> 2. In cases where no
                  further payments are outstanding or the payments are
                  inadequate to cover the refunded sums, necessitate that the
                  instructor reimburses any amounts refunded to learners for
                  their Submitted Content.
                </p>
                <h2>Trademarks</h2>
                <p>
                  As a published instructor, you are permitted to use our
                  trademarks only in the ways that we explicitly authorize. This
                  includes:
                </p>
                <ul>
                  <li>
                    Using only the images of our trademarks that we provide to
                    you, following any guidelines we may publish, and limiting
                    the use of our trademarks to the promotion and sale of your
                    Submitted Content on Takbir or your participation on Takbir.{" "}
                  </li>
                  <li>
                    You must comply immediately if we request that you stop
                    using our trademarks.{" "}
                  </li>
                  <li>
                    Additionally, you must not use our trademarks in a
                    misleading or derogatory manner, imply that we endorse,
                    sponsor, or approve of your Submitted Content or services,
                    or use our trademarks in connection with obscene, indecent,
                    or unlawful material or topics that violate applicable law.
                  </li>
                </ul>
                <h2>Deleting Your Account</h2>
                <p>
                  If learners have enrolled in your Submitted Content before,
                  it's possible that they may still have access to your name and
                  that Submitted Content even after you delete your account. In
                  case you face any issues while deleting your account, please
                  feel free to reach out to us through our{" "}
                  <a href="https://support.mytakbir.com/">Support Center</a> for
                  assistance.
                </p>
                <h2>Contact us</h2>
                <p>
                  To get in touch with us is to contact our{" "}
                  <a href="https://support.mytakbir.com/">Support Team.</a> We
                  welcome your inquiries, worries, and comments regarding our
                  Services.
                </p>
                {/* <h2>What Information We Collect</h2>
                <p>
                  We gather the following types of information about users
                  through the Site:
                </p>

                <ol>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                </ol> */}
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div>
        <Footer />
      </div>
    </div>
  );
}

export default InstructorTerms;
